import styled from "styled-components";

export const TelaInicialStyle = styled.div`
  p {
    text-align: left;
  }

  .code-container{
    background-color: #111;    
    padding: 0.5rem;   
  } 
`;
